import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from './AuthContext';

const RoleBasedRoute = ({ children, requiredPermission }) => {
  const { isAuthenticated, loading, hasPermission } = useAuth();

  console.log('RoleBasedRoute: loading:', loading, 'isAuthenticated:', isAuthenticated, 'requiredPermission:', requiredPermission);

  if (loading) {
    return (
      <div className="loading-container">
        <div className="loading-spinner"></div>
        <p>Loading...</p>
      </div>
    );
  }

  if (!isAuthenticated) {
    console.log('RoleBasedRoute: Redirecting to login');
    return <Navigate to="/login" replace />;
  }

  if (!hasPermission(requiredPermission)) {
    console.log('RoleBasedRoute: Access denied - insufficient permissions');
    return <Navigate to="/select-competition" replace />;
  }

  console.log('RoleBasedRoute: Access granted, rendering children');
  return children;
};

export default RoleBasedRoute;